import { ArrowUpRight, BriefcaseBusiness, IndianRupee, MapPin, Sparkles, Users } from "lucide-react";
import { Link } from "react-router-dom";
import { useSiteContent } from "../content/SiteContentContext";

const badgeClass = {
  NAPS: "scheme-naps",
  NATS: "scheme-nats",
  Direct: "scheme-direct",
  "Regular Job": "scheme-regular-job",
};

export default function JobCard({ job, index }) {
  const { content } = useSiteContent();
  return (
    <article className="job-card animate-in" style={{ animationDelay: `${index * 65}ms` }} data-testid={`job-card-${job.id}`}>
      <div className="job-card-topline">
        <span className={`scheme-badge ${badgeClass[job.scheme]}`} data-testid={`job-scheme-${job.id}`}>{job.scheme}</span>
        <span className="job-age" data-testid={`job-openings-${job.id}`}>{job.openings} openings</span>
      </div>
      <div className="job-title-block">
        <h3 data-testid={`job-title-${job.id}`}>{job.title}</h3>
        <p data-testid={`job-company-${job.id}`}>{job.company}</p>
      </div>
      <div className="job-meta" data-testid={`job-meta-${job.id}`}>
        <span><MapPin size={16} /><b>Location:</b> {job.location}</span>
        <span><IndianRupee size={16} /><b>Salary:</b> {job.stipend}</span>
        <span><BriefcaseBusiness size={16} /><b>Education:</b> {job.education}</span>
        <span><Users size={16} /><b>Trade:</b> {job.trade}</span>
        <span data-testid={`job-experience-${job.id}`}><Sparkles size={16} /><b>Experience:</b> {job.experience || "Fresher"}</span>
      </div>
      {job.facilities?.length > 0 && <div className="job-card-facilities" data-testid={`job-card-facilities-${job.id}`}><strong>Facilities:</strong><span>{job.facilities.join(" · ")}</span></div>}
      <Link to={`/jobs/${job.slug || job.id}`} className="job-card-link" data-testid={`view-job-${job.id}`}>
        {content.job_view_label} <ArrowUpRight size={17} />
      </Link>
    </article>
  );
}